export const SIDEBAR_WIDTH = 217;
export const SIDEBAR_CLOSED_WIDTH = 53;

export const VIEW_PATIENT_SCREEN_NAME = 'View_Patient';
